import styled from 'styled-components';
import Select from 'react-select';
const initialList = [
  '전체',
  'ㄱ',
  'ㄴ',
  'ㄷ',
  'ㄹ',
  'ㅁ',
  'ㅂ',
  'ㅅ',
  'ㅇ',
  'ㅈ',
  'ㅊ',
  'ㅋ',
  'ㅌ',
  'ㅍ',
  'ㅎ',
];

interface Props {
  initial: string;
  setInitial: (initial: string) => void;
}

function InitialFilter({ initial, setInitial }: Props) {
  const initialOptions = initialList.map((item) => ({
    value: item,
    label: item,
    isDisabled: ['ㄴ', 'ㄹ', 'ㅋ'].includes(item),
  }));

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      width: '99px',
      minHeight: '40px',
      height: '40px',
      flexDirection: 'row',
      borderRadius: '8px',
      border: '1px solid #E1E2E4',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '16px',
      fontWeight: 500,
      padding: '8px 12px',
      alignContent: 'center',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
      paddingLeft: '0px',
      paddingRight: '0px',
      svg: {
        width: 16,
        height: 16,
      },
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    menu: (provided: any) => ({
      ...provided,

      paddingTop: '8px',
      paddingBottom: '8px',
      border: '1px solid #E1E2E4',
      boxShadow: '0px 4px 15px 0px #8D95A340',
    }),
    menuList: (provided: any) => ({
      ...provided,
      maxHeight: '280px',
      overflowY: 'auto',
      padding: '8px',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      padding: '8px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '14px',
      fontWeight: 500,
      backgroundColor: state.isDisabled
        ? 'transparent'
        : state.isFocused
          ? '#0000000A'
          : state.isSelected
            ? '#e6e6e6'
            : 'white',
      color: state.isDisabled
        ? '#37383C29'
        : state.isSelected
          ? '#000'
          : '#333',
      borderRadius: '4px',
    }),
  };

  return (
    <>
      <Select
        options={initialOptions}
        styles={customStyles}
        placeholder="전체"
        value={{ value: initial, label: initial }}
        onChange={(selectedOption) => {
          if (selectedOption) {
            setInitial(selectedOption.value);
          }
        }}
      />
    </>
  );
}

export default InitialFilter;
